import clsx from "clsx";
import Flex from "components/Flex";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { bool, func, number, string } from "prop-types";

import styles from "./ItemStepper.module.scss";

const ItemStepper = ({
  canLoop = true,
  className,
  current = 1,
  nextLabel = "Next",
  onUpdate,
  previousLabel = "Previous",
  separator = "of",
  total,
}) => {
  const onClickPrev = (e) => {
    let prevStep;
    if (canLoop) {
      prevStep = current - 1 < 1 ? total : current - 1;
    } else {
      prevStep = Math.max(1, current - 1);
    }
    onUpdate(e, prevStep);
  };

  const onClickNext = (e) => {
    let nextStep;
    if (canLoop) {
      nextStep = current + 1 > total ? 1 : current + 1;
    } else {
      nextStep = Math.min(current + 1, total);
    }
    onUpdate(e, nextStep);
  };

  return (
    <Flex className={clsx(styles.stepper, className)}>
      <button
        type="button"
        className={styles.stepButton}
        aria-label={previousLabel}
        disabled={!canLoop && Math.max(1, current) <= 1}
        onClick={onClickPrev}
      >
        <ChevronLeft size={12} aria-hidden />
      </button>

      <span className={styles.stepPosition}>
        {current} {separator} {total}
      </span>

      <button
        type="button"
        className={styles.stepButton}
        aria-label={nextLabel}
        disabled={!canLoop && Math.min(total, current) >= total}
        onClick={onClickNext}
      >
        <ChevronRight size={12} aria-hidden />
      </button>
    </Flex>
  );
};

ItemStepper.propTypes = {
  canLoop: bool,
  className: string,
  current: number,
  nextLabel: string,
  onUpdate: func.isRequired,
  previousLabel: string,
  separator: string,
  total: number.isRequired,
};

export default ItemStepper;
